// extracted by mini-css-extract-plugin
export default {"list--logos":"Footer_list--logos__pDO0X","list_item":"Footer_list_item__zyALS","border":"Footer_border__AK0Gs","m_bottom":"Footer_m_bottom__iih9D"};